import { Bell, LogOut, Menu, MessageCircle, PanelRightOpen, User, Shield } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';

const APP_ENV = process.env.REACT_APP_ENV || 'prod';

export default function TopBar({ onMenuClick, onChatToggle, onChatCollapse, chatCollapsed }) {
  const { email, logout, isAdmin } = useAuth();

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 lg:px-6">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 -ml-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg"
        >
          <Menu className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-2">
          <div>
            <h2 className="text-sm font-semibold text-slate-900">AgentDash</h2>
            <p className="text-xs text-slate-500">MSP Sales Intelligence</p>
          </div>
          {APP_ENV === 'dev' && (
            <span className="px-1.5 py-0.5 text-[10px] font-bold uppercase bg-orange-100 text-orange-700 border border-orange-200 rounded">
              DEV
            </span>
          )}
          {isAdmin && (
            <span className="hidden sm:flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-medium bg-purple-50 text-purple-600 border border-purple-200 rounded">
              <Shield className="w-3 h-3" />
              Admin
            </span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={onChatToggle}
          className="lg:hidden p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg"
        >
          <MessageCircle className="w-5 h-5" />
        </button>

        {chatCollapsed && (
          <button
            onClick={onChatCollapse}
            className="hidden lg:block p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg"
            title="Open Assistant"
          >
            <PanelRightOpen className="w-5 h-5" />
          </button>
        )}

        <button className="relative p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg">
          <Bell className="w-5 h-5" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full" />
        </button>

        {email && (
          <span className="hidden sm:block text-xs text-slate-500 max-w-[160px] truncate">
            {email}
          </span>
        )}

        <div className="w-8 h-8 bg-primary-100 text-primary-700 rounded-full flex items-center justify-center">
          <User className="w-4 h-4" />
        </div>

        <button
          onClick={logout}
          title="Sign out"
          className="p-2 text-slate-400 hover:text-red-600 hover:bg-slate-100 rounded-lg transition-colors"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
}
